export default __webpack_public_path__ + "static/media/demonavenger.07df2fef.png";